import React, { useEffect, useState } from "react";
import { Button, DatePicker } from "antd";
import moment from "moment";
import AppInput from "../../../../components/AppInput";
import VoyageDetails from "../../../../components/VoyageDetails";
import { useNavigate, useParams } from "react-router-dom";
import { post } from "../../../../services/services";
import { ApiURL } from "../../../../services/apiConstants";
import { ErrorToast, SuccessToast } from "../../../../widgets/AppToast";
import useUserData from "../../../../hooks/useUserData";
import SecurityCodeModal from "../../../../components/SecurityCodeModal";

function EditBunkerFuelChangeover() {
  const { fuel_id } = useParams();
  const navigate = useNavigate();
  const user = useUserData();
  const [staff_dashboard, set_staff_dashboard] = useState([]);
  const [submitStatus, setSubmitStatus] = useState(false);
  const [soft_delete, set_Soft_Dlt] = useState("");
  const [initialFormState, setInitialFormState] = useState({});
  const [loader, set_loader] = useState(false);
  const [modalVisible, setModalVisible] = useState(false);
  const [form, setForm] = useState({
    changeOverCompletion: null,
    shipPositionCompletion: "",
    lowSulphurQtyAfter: "",
    ecaEntry: null,
    ecaExit: null,
    changeOverToHighSulphur: null,
    shipPositionHighSulphur: "",
    lowSulphurQtyBefore: "",
    remarks: "",
    chiefEngSign: "",
  });
  const [errors, setErrors] = useState({});

  useEffect(() => {
    const staff_dashboards = localStorage.getItem("staff_dashboard");
    try {
      if (staff_dashboards) {
        const parsedData = JSON.parse(staff_dashboards);
        set_staff_dashboard(parsedData);
        VIEW_FUEL_CHARGEOVER_DETAILS(parsedData);
      }
    } catch (err) {
      console.error("Error parsing staff_dashboard:", err);
    }
  }, []);

  const handleChange = (key, value) => {
    setForm((prev) => ({ ...prev, [key]: value }));
    setErrors((prev) => ({ ...prev, [key]: "" }));
  };

  const UPDATE_FUEL_CHARGEOVER_DETAILS = (save_submit) => {
    try {
      let newErrors = {};

if (!form.changeOverCompletion) {
  newErrors.changeOverCompletion = "This field is required";
}

if (!form.ecaEntry) {
  newErrors.ecaEntry = "This field is required";
}

if (!form.ecaExit) {
  newErrors.ecaExit = "This field is required";
}

if (!form.changeOverToHighSulphur) {
  newErrors.changeOverToHighSulphur = "This field is required";
}

if (Object.keys(newErrors).length > 0) {
  setErrors(newErrors);
  return; // 🚫 STOP API CALL
}
      set_loader(true);
      const formData = new FormData();
      const formatDate = (date) =>
  date ? date.format("YYYY-MM-DD HH:mm:ss") : null;

      formData.append("request_type", "edit");
      formData.append("record_id", atob(fuel_id));
      formData.append("save_submit", Number(save_submit) || 0);
      formData.append("voyage_id", staff_dashboard?.voyage_details[0]?.id);
      // formData.append(
      //   "date_and_time_completion",
      //   form.changeOverCompletion && moment.isMoment(form.changeOverCompletion)
      //     ? form.changeOverCompletion.format("YYYY-MM-DD HH:mm:ss")
      //     : ""
      // );
      formData.append("date_and_time_completion", formatDate(form.changeOverCompletion));
      formData.append("ship_position", form.shipPositionCompletion || "");
      formData.append("low_sulphur_quality_completion", form.lowSulphurQtyAfter || "");
      // formData.append(
      //   "date_and_time_entry_eca",
      //   form.ecaEntry && moment.isMoment(form.ecaEntry)
      //     ? form.ecaEntry.format("YYYY-MM-DD HH:mm:ss")
      //     : ""
      // );
      formData.append("date_and_time_entry_eca", formatDate(form.ecaEntry));
      // formData.append(
      //   "date_and_time_exit_eca",
      //   form.ecaExit && moment.isMoment(form.ecaExit)
      //     ? form.ecaExit.format("YYYY-MM-DD HH:mm:ss")
      //     : ""
      // );
      formData.append("date_and_time_exit_eca", formatDate(form.ecaExit));
      // formData.append(
      //   "date_and_time_changeover_high_sulphur",
      //   form.changeOverToHighSulphur && moment.isMoment(form.changeOverToHighSulphur)
      //     ? form.changeOverToHighSulphur.format("YYYY-MM-DD HH:mm:ss")
      //     : ""
      // );
      formData.append("date_and_time_changeover_high_sulphur", formatDate(form.changeOverToHighSulphur));
      formData.append("ship_position_high_sulphur", form.shipPositionHighSulphur || "");
      formData.append("low_sulphur_quality_start", form.lowSulphurQtyBefore || "");
      formData.append("chief_eng_name_sign", form.chiefEngSign || "");
      formData.append("remarks", form.remarks || "");

      post(ApiURL?.view_bunker_fuel_chargerover_st_fcr, formData)
        .then((res) => {
          const responseData = res?.response?.data || res;
          if (responseData?.status === true) {
            SuccessToast("Success!", "Fuel changeover record updated successfully");
            navigate("/list-fuel-changeover");
            set_loader(false);
          } else {
            let newErrors = responseData?.errors || {};
            // Direct error mapping
            if (responseData?.error && typeof responseData.error === "string") {
              const err = responseData.error.toLowerCase();
              if (err.includes("date_and_time_completion")) newErrors.changeOverCompletion = responseData.error;
              if (err.includes("date_and_time_entry_eca")) newErrors.ecaEntry = responseData.error;
              if (err.includes("date_and_time_exit_eca")) newErrors.ecaExit = responseData.error;
              if (err.includes("date_and_time_changeover_high_sulphur")) newErrors.changeOverToHighSulphur = responseData.error;
            }
            setErrors(newErrors);
            if (Object.keys(newErrors).length === 0) {
              ErrorToast("Error", responseData?.message || responseData?.error || "Check your details.");
            }
            set_loader(false);
          }
        })
        .catch((error) => {
          set_loader(false);
          ErrorToast("Error", "Server side error occurred.");
          console.error("Error while updating fuel changeover:", error);
        });
    } catch (error) {
      set_loader(false);
      console.error("Unexpected error in update hook:", error);
    }
  };

  const VIEW_FUEL_CHARGEOVER_DETAILS = async (voyage_data) => {
    try {
      const FORM_DATA = new FormData();
      FORM_DATA.append("voyage_id", voyage_data?.voyage_details?.[0]?.id);
      FORM_DATA.append("record_id", atob(fuel_id));
      FORM_DATA.append("request_type", "view");
      const response = await post(
        ApiURL?.view_bunker_fuel_chargerover_st_fcr,
        FORM_DATA
      );

      if (response?.status == true) {
        const data = response?.data;
        setSubmitStatus(data?.submit_status);
        set_Soft_Dlt(data?.soft_delete);
        const mappedData = {
          changeOverCompletion: data?.date_and_time_completion
            ? moment(data.date_and_time_completion)
            : moment(),
          shipPositionCompletion: data?.ship_position || "",
          lowSulphurQtyAfter: data?.low_sulphur_quality_completion || "",
          ecaEntry: data?.date_and_time_entry_eca
            ? moment(data.date_and_time_entry_eca)
            : moment(),
          ecaExit: data?.date_and_time_exit_eca
            ? moment(data.date_and_time_exit_eca)
            : moment(),
          changeOverToHighSulphur: data?.date_and_time_changeover_high_sulphur
            ? moment(data.date_and_time_changeover_high_sulphur)
            : moment(),
          shipPositionHighSulphur: data?.ship_position_high_sulphur || "",
          lowSulphurQtyBefore: data?.low_sulphur_quality_start || "",
          remarks: data?.remarks || "",
          chiefEngSign: data?.chief_eng_name_sign || "",
        };

        setForm(mappedData);
        setInitialFormState(mappedData);
      } else {
        console.error("Failed to fetch bunker delivery details:", response);
      }
    } catch (error) {
      console.error("Error in VIEW_FUEL_CHARGEOVER_DETAILS:", error);
    }
  };

  return (
    <>
      <VoyageDetails staff_dashboard={staff_dashboard?.voyage_details} />
      <div className="white-container">
        <h3>Edit Fuel Changeover Record</h3>
        <br />

        <div className="row">
          <div className="col-6">
            <div className="input-box">
              <label>Date & Time of Completion (Low Sulphur)</label>
              <DatePicker
                showTime
                value={form.changeOverCompletion}
                onChange={(date) => handleChange("changeOverCompletion", date)}
                style={{ width: "100%" }}
                format="YYYY-MM-DD HH:mm:ss"
                disabled={submitStatus}
              />
              {errors.date_and_time_completion || errors.changeOverCompletion ? (
                <span style={{ color: "red" }}>
                  {errors.date_and_time_completion || errors.changeOverCompletion}
                </span>
              ) : null}
            </div>
          </div>
          <div className="col-6">
            <AppInput
              label="Ship's Position (Completion)"
              value={form.shipPositionCompletion}
              onChange={(e) =>
                handleChange("shipPositionCompletion", e.target.value)
              }
              disabled={submitStatus}
              errors={errors.ship_position || errors.shipPositionCompletion}
            />
          </div>
        </div>

        <div className="row">
          <div className="col-6">
            <AppInput
              label="Low Sulphur Quantity at Completion (Tank ID/m3)"
              value={form.lowSulphurQtyAfter}
              onChange={(e) =>
                handleChange("lowSulphurQtyAfter", e.target.value)
              }
              disabled={submitStatus}
              errors={errors.low_sulphur_quality_completion || errors.lowSulphurQtyAfter}
            />
          </div>
        </div>

        <div className="row">
          <div className="col-6">
            <div className="input-box">
              <label>Date & Time of Entry into ECA-Sox</label>
              <DatePicker
                showTime
                value={form.ecaEntry}
                onChange={(date) => handleChange("ecaEntry", date)}
                style={{ width: "100%" }}
                format="YYYY-MM-DD HH:mm:ss"
                disabled={submitStatus}
              />
              {errors.date_and_time_entry_eca || errors.ecaEntry ? (
                <span style={{ color: "red" }}>
                  {errors.date_and_time_entry_eca || errors.ecaEntry}
                </span>
              ) : null}
            </div>
          </div>
          <div className="col-6">
            <div className="input-box">
              <label>Date & Time of Exit from ECA-Sox</label>
              <DatePicker
                showTime
                value={form.ecaExit}
                onChange={(date) => handleChange("ecaExit", date)}
                style={{ width: "100%" }}
                format="YYYY-MM-DD HH:mm:ss"
                disabled={submitStatus}
              />
              {errors.date_and_time_exit_eca || errors.ecaExit ? (
                <span style={{ color: "red" }}>
                  {errors.date_and_time_exit_eca || errors.ecaExit}
                </span>
              ) : null}
            </div>
          </div>
        </div>

        <div className="row">
          <div className="col-6">
            <div className="input-box">
              <label>Date & Time of Changeover to High Sulphur</label>
              <DatePicker
                showTime
                value={form.changeOverToHighSulphur}
                onChange={(date) =>
                  handleChange("changeOverToHighSulphur", date)
                }
                style={{ width: "100%" }}
                format="YYYY-MM-DD HH:mm:ss"
                disabled={submitStatus}
              />
              {errors.date_and_time_changeover_high_sulphur || errors.changeOverToHighSulphur ? (
                <span style={{ color: "red" }}>
                  {errors.date_and_time_changeover_high_sulphur || errors.changeOverToHighSulphur}
                </span>
              ) : null}
            </div>
          </div>
          <div className="col-6">
            <AppInput
              label="Ship's Position (High Sulphur Start)"
              value={form.shipPositionHighSulphur}
              onChange={(e) =>
                handleChange("shipPositionHighSulphur", e.target.value)
              }
              disabled={submitStatus}
              errors={errors.ship_position_high_sulphur || errors.shipPositionHighSulphur}
            />
          </div>
        </div>

        <div className="row">
          <div className="col-6">
            <AppInput
              label="Low Sulphur Quantity at Start (Tank ID/m3)"
              value={form.lowSulphurQtyBefore}
              onChange={(e) =>
                handleChange("lowSulphurQtyBefore", e.target.value)
              }
              disabled={submitStatus}
              errors={errors.low_sulphur_quality_start || errors.lowSulphurQtyBefore}
            />
          </div>
        </div>

        <div className="row">
          <div className="col-6">
            <AppInput
              label="Remarks"
              value={form.remarks}
              onChange={(e) => handleChange("remarks", e.target.value)}
              disabled={submitStatus}
            />
          </div>
          <div className="col-6">
            <AppInput
              label="Chief Eng. Name & Digital Signature"
              value={form.chiefEngSign}
              onChange={(e) => handleChange("chiefEngSign", e.target.value)}
              disabled={submitStatus}
              errors={errors.chief_eng_name_sign || errors.chiefEngSign}
            />
          </div>
        </div>

        <div className="row">
          {soft_delete ||
            (user?.data?.designation === "Chief Engineer" && fuel_id && (
              <>
                <div
                  className="input-box"
                  style={{ marginLeft: "15px", marginTop: "15px" }}
                >
                  <Button
                    loading={loader}
                    disabled={submitStatus}
                    className="save_btn"
                    style={{ color: "white" }}
                    onClick={() => setModalVisible(true)}
                  >
                    Submit
                  </Button>
                </div>
              </>
            ))}
        </div>
        <SecurityCodeModal
          record_id={atob(fuel_id)}
          visible={modalVisible}
          setModalVisible={setModalVisible}
          onCancel={() => setModalVisible(false)}
          onSuccess={() => {
            UPDATE_FUEL_CHARGEOVER_DETAILS("1");
            setModalVisible(false);
          }}
          apiEndPoint={ApiURL.verify_security_code_st}
        />
      </div>
    </>
  );
}

export default EditBunkerFuelChangeover;
